import React, { PureComponent } from 'react';
import styled from 'styled-components';
import COLORS from 'constants/colors';
import { TextInput } from '@cuemath/comps';
import PropTypes from 'prop-types';

const Field = styled.div`
  width: 65%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ profileView }) => `${profileView ? '10px' : '12px'}`};
`;

const Label = styled.label`
  width: 25%;
  display: flex;
  justify-content: left;
`;

const Flex = styled.div`
  width: 75%;
  display: flex;
  gap: ${({ gap }) => `${gap ? '10px' : '20px'}`};
`;

const CustomInput = styled(TextInput)`
  width: ${({ profileView }) => `${profileView ? '300px' : '100px'}`};
  height: 35px;
  padding: 15px 10px;
  outline: none;
  display: inline-block;
  background-color: ${({ disabled }) => `${disabled ? COLORS.READONLY : COLORS.WHITE}`};
  &:focus {
    border: 3px solid #c4dffe;
    &::placeholder {
      opacity: 0;
    }
  }
`;

const Span = styled.span`
  display: flex;
  align-items: center;
`;

export default class InputForm extends PureComponent {
  static propTypes = {
    selectedValue: PropTypes.shape({}).isRequired,
    onInputChange: PropTypes.func.isRequired,
  };

  render() {
    const { selectedValue, value, disabled, onInputChange } = this.props;
    const { label: tagLabel, name: tagName, type: tagType, placeholder } =
      selectedValue || {};
    return (
      <Field justifyContent>
        <Label>{tagLabel}</Label>
        <Flex gap>
          <CustomInput
            name={tagName}
            type={tagType}
            value={value || selectedValue.default}
            onChange={e => onInputChange(e, tagName)}
            disabled={disabled}
          />
          <Span>
            <div>{placeholder}</div>
          </Span>
        </Flex>
      </Field>
    );
  }
}
